module.exports = __webpack_public_path__ + "img/ch75.925b9dbf.jpg";